<template>
  <div class="segment-chart" :class="className" v-inview="{ callback: onInview }">
    <div class="segment-chart__caption">{{ caption }}</div>
    <div class="segment-chart__bar">
      <div class="segment-chart__proportion"
        v-for="(data, index) in dataSource"
        :key="index"
        :style="`width: ${data.percent};`">
        <div class="segment-chart__rect" :style="`background: ${data.color}`" :title="data.percent"></div>
        <div class="segment-chart__info">
          <div class="segment-chart__value" :style="`color: ${data.color}`">{{ data.percent }}</div>
          <div class="segment-chart__label" :style="`color: ${data.color}`" :title="data.label" v-if="labels && labels.length">{{ data.label }}</div>
          <div class="segment-chart__role" v-if="roles && roles.length"><!--
          --><ul class="segment-chart__role-list" :title="data.role.toString()">
              <li class="segment-chart__role-item" v-for="item in data.role" :key="item">{{ item }}</li>
            </ul><!--
          --><div class="segment-chart__role-winner" :style="`background-color: ${winnerColor}`" v-if="index === 0">勝</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SegmentChart',
  props: {
    caption: { type: String, default: '' },
    winnerColor: { type: String, default: '#1a1a1a' },
    colors: { type: Array, default: () => [] },
    values: { type: Array, default: () => [] },
    labels: { type: Array, default: () => [] },
    roles: { type: Array, default: () => [] }
  },
  data () {
    return {
      data: [],
      isInview: false
    }
  },
  computed: {
    className () {
      return {
        'segment-chart--inview': this.isInview
      }
    },
    dataSource () {
      const { percentage } = this.$options.filters
      return this.values.map((value, index) => {
        let color = this.colors[index]
        let percent = percentage(value)
        let label = this.labels[index] || ''
        let role = this.roles[index]
        return {
          index,
          value,
          percent,
          color,
          label,
          role
        }
      })
    }
  },
  methods: {
    onInview () {
      this.isInview = true
    }
  }
}
</script>

<style lang="scss">
.segment-chart {
  $comp: &;
  font-weight: 500;

  &__caption {
    margin-left: 10px;
    font-size: 0.75em;
    opacity: 0;
    transform: translateX(-5px);
    transition:
      opacity 0.3s,
      transform 0.3s;
    @include rwd($RWD_TABLET_SMALL) {
      margin-left: 0;
      font-size: 0.875em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1em;
    }
  }

  &__bar {
    white-space: nowrap;
    overflow: hidden;
  }

  &__proportion {
    display: inline-block;
    position: relative;
    vertical-align: top;
    @include rwd($RWD_TABLET_SMALL) {
      margin-top: 3px;
    }

    &:last-child {
      #{$comp}__info {
        position: absolute;
        right: 10px;
        @include rwd($RWD_TABLET_SMALL) {
          right: 0;
        }
      }
      #{$comp}__value,
      #{$comp}__label,
      #{$comp}__role {
        margin-left: 0;
        text-align: right;
      }
    }
  }

  &__rect {
    height: 25px;
    background: #a1a1a1;
    opacity: 0;
    backface-visibility: hidden;
    transform-origin: top left;
    transform: scaleX(0);
    transition:
      opacity 0.4s,
      transform 0.4s;
  }

  &__info {
    opacity: 0;
    transform: translateX(-10px);
    transition:
      transform 0.4s,
      opacity 0.4s;
  }

  &__value {
    margin-left: 10px;
    font-size: 0.75em;
    @include rwd($RWD_TABLET_SMALL) {
      margin-left: 0;
      font-size: 0.875em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1em;
    }
  }

  &__label {
    margin-left: 10px;
    font-size: 1.125em;
    @include rwd($RWD_TABLET_SMALL) {
      margin-left: 0;
      font-size: 1.25em;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 5px;
      font-size: 1.375em;
    }
  }

  &__role {
    margin-top: 2px;
    margin-left: 10px;
    @include use-vertical-align();
    @include rwd($RWD_TABLET_SMALL) {
      margin-left: 0;
    }
    @include rwd($RWD_TABLET) {
      margin-top: 5px;
    }
  }

  &__role-list {
    display: inline-block;
    vertical-align: middle;
  }

  &__role-item {
    display: block;
    font-size: 0.875em;
    @include rwd($RWD_TABLET_SMALL) {
      font-size: 1em;
    }
    @include rwd($RWD_TABLET) {
      font-size: 1.125em;
    }
  }

  &__role-winner {
    display: inline-block;
    width: 22px;
    height: 22px;
    margin-left: 10px;
    color: white;
    font-size: 13px;
    font-weight: normal;
    line-height: 20px;
    text-align: center;
    vertical-align: middle;
    background: #a1a1a1;
    border-radius: 4px;
  }

  &--inview {
    #{$comp}__caption {
      opacity: 1;
      transform: translateX(0);
    }

    #{$comp}__proportion {
      &:nth-child(1) {
        #{$comp}__rect,
        #{$comp}__info {
          transition-delay: 0;
        }
      }
      &:nth-child(2) {
        #{$comp}__rect,
        #{$comp}__info {
          transition-delay: 0.4s;
        }
      }
      &:nth-child(3) {
        #{$comp}__rect,
        #{$comp}__info {
          transition-delay: 0.8s;
        }
      }
    }

    #{$comp}__rect {
      opacity: 1;
      transform: scaleX(1);
    }

    #{$comp}__info {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
</style>
